import { pad } from '../pad'

export const dayShorts = {
      cs: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
      en: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
} as {
      [keyof: string]: string[]
}

export const dayLong = {
      cs: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
      en: ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'],
} as {
      [keyof: string]: string[]
}

let locale = 'cs'

export function formatTime(date: Date) {
      let _time = ''

      _time += pad(String(date.getHours()))
      _time += ':'
      _time += pad(String(date.getMinutes()))

      return _time
}

export function getLocaleDay(date: Date, long = false, locale: string = "cs") {
  if( long ) return dayLong[locale][date.getDay()]
  return dayShorts[locale][date.getDay()]
}

export function formatDate(date: Date) {
      let _date = ''
      _date += date.getDate()
      _date += '. '
      _date += date.getMonth() + 1
      _date += '. '

      return _date
}
